var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "pb-2 cursor-pointer layers-header" }, [
        _c("div", { staticClass: "d-flex align-items-center gap-2" }, [
          _c(
            "p",
            { staticClass: "text-sm m-0" },
            [
              _c("b-icon", {
                staticClass: "mr-1 custom-green-icon",
                attrs: { icon: "layers" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "font-semibold" }, [_vm._v("Layers")]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.selectionCount > 0
            ? _c(
                "span",
                { staticClass: "text-muted text-xs bg-light rounded p-1" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.selectionCount) +
                      " selected\n      "
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("b-form-checkbox", {
              staticClass: "mb-0",
              attrs: { switch: "" },
              model: {
                value: _vm.showDeletedLayers,
                callback: function ($$v) {
                  _vm.showDeletedLayers = $$v
                },
                expression: "showDeletedLayers",
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "text-xs text-muted mb-0" }, [
              _vm._v("Deleted"),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-list-group",
        [
          _c(
            "draggable",
            {
              attrs: {
                id: "layers-list",
                list: _vm.layersOrdered,
                group: "layers",
              },
              on: { end: _vm.dragEnd, start: _vm.dragStart },
            },
            _vm._l(_vm.layersOrdered, function (field) {
              return _c(
                "b-list-group-item",
                {
                  key: field.id,
                  class: [
                    !field.relatedCanvasObject && !_vm.showDeletedLayers
                      ? "d-none"
                      : "d-flex",
                    "justify-content-between align-items-center px-2 py-1 primary-border-color",
                    { "font-weight-bold": !!field.relatedCanvasObject },
                  ],
                  attrs: {
                    "data-v-key": field.id,
                    button: "",
                    active: _vm.isActive(field),
                    variant: _vm.listItemVariant(field),
                  },
                  on: {
                    click: (e) =>
                      _vm.setActiveObject(field.relatedCanvasObject, e),
                    mouseenter: function ($event) {
                      _vm.hoveredLayerId = field.id
                    },
                    mouseleave: function ($event) {
                      _vm.hoveredLayerId = null
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-items-center layer-icons",
                      staticStyle: { "min-width": "40px", gap: "8px" },
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: _vm.getIcon(field.relatedCanvasObject) },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return ((e) =>
                              _vm.handleLayerVisibility(
                                field.relatedCanvasObject,
                                e
                              )).apply(null, arguments)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.isTextLayer(field.relatedCanvasObject)
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  value: "Edit text",
                                  expression: "'Edit text'",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticClass:
                                "text-layer-icon cursor-pointer d-flex align-items-center justify-content-center text-xs text-muted",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.editTextLayer(
                                    field.relatedCanvasObject
                                  )
                                },
                              },
                            },
                            [_vm._v("T")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isSeeThrough(field.relatedCanvasObject) ||
                      _vm.hoveredLayerId === field.id ||
                      (_vm.isActive(field) &&
                        _vm.isSeeThrough(field.relatedCanvasObject))
                        ? _c("img", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName:
                                  "v-b-tooltip.hover.viewport.noninteractive",
                                value: _vm.isSeeThrough(
                                  field.relatedCanvasObject
                                )
                                  ? "Restore"
                                  : "See-Through",
                                expression:
                                  "isSeeThrough(field.relatedCanvasObject) ? 'Restore' : 'See-Through'",
                                modifiers: {
                                  hover: true,
                                  viewport: true,
                                  noninteractive: true,
                                },
                              },
                            ],
                            staticClass: "cursor-pointer",
                            class: {
                              "see-through-selected": _vm.isActive(field),
                            },
                            staticStyle: { width: "16px", height: "16px" },
                            attrs: {
                              src: _vm.isSeeThrough(field.relatedCanvasObject)
                                ? "/images/see-through-active.svg"
                                : "/images/see-through-hover.svg",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.toggleSeeThrough(
                                  field.relatedCanvasObject
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      field.relatedCanvasObject?.isClippingMask
                        ? _c("b-icon", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName:
                                  "v-b-tooltip.hover.viewport.noninteractive",
                                value: "Clipping mask",
                                expression: "'Clipping mask'",
                                modifiers: {
                                  hover: true,
                                  viewport: true,
                                  noninteractive: true,
                                },
                              },
                            ],
                            attrs: { icon: "arrow90deg-down" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex-grow-1 text-center text-truncate px-2",
                    },
                    [
                      _vm.isOffScreen(field.relatedCanvasObject) &&
                      !_vm.isDuplicating
                        ? _c("b-icon", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName:
                                  "v-b-tooltip.hover.viewport.noninteractive",
                                value:
                                  "This item is off-screen. Click to center it",
                                expression:
                                  "'This item is off-screen. Click to center it'",
                                modifiers: {
                                  hover: true,
                                  viewport: true,
                                  noninteractive: true,
                                },
                              },
                            ],
                            staticClass: "rounded-circle bg-primary mr-1",
                            attrs: { icon: "bullseye", variant: "light" },
                            on: {
                              click: function ($event) {
                                return _vm.reposition(field.relatedCanvasObject)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !!field?.note
                        ? _c(
                            "b-tooltip",
                            {
                              attrs: {
                                target: `note-${field.id}`,
                                triggers: "hover",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(field.note) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "field-name",
                          attrs: {
                            title: field.name,
                            disabled: _vm.isTooltipDisabled(field.name),
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(field.name) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      !!field?.note
                        ? _c("b-icon", {
                            staticClass: "ml-1",
                            attrs: {
                              id: `note-${field.id}`,
                              icon: "info-circle",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-end",
                      staticStyle: { "min-width": "24px" },
                    },
                    [
                      _vm.isImageLayer(field) && !!field.relatedCanvasObject
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName:
                                    "v-b-tooltip.hover.viewport.noninteractive",
                                  value: "Replace image",
                                  expression: "'Replace image'",
                                  modifiers: {
                                    hover: true,
                                    viewport: true,
                                    noninteractive: true,
                                  },
                                },
                              ],
                              staticClass: "cursor-pointer",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleReplace(field)
                                },
                              },
                            },
                            [_c("i", { staticClass: "bi bi-repeat" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("b-icon", { attrs: { icon: "grip-vertical" } }),
                    ],
                    1
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center justify-content-between mt-2 gap-2",
        },
        [
          _c(
            "b-dropdown",
            {
              staticClass: "custom-split-dropdown flex-grow-1",
              attrs: {
                size: "sm",
                variant: "outline-primary",
                split: "",
                text: "Select product images",
              },
              on: { click: _vm.selectProductImages },
            },
            [
              _c("b-dropdown-item", { on: { click: _vm.selectAllImages } }, [
                _vm._v("\n        Select all images\n      "),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: {
                disabled: _vm.selectionCount === 0,
                size: "sm",
                variant: "outline-primary custom-secondary-button flex-grow-1",
              },
              on: { click: _vm.deselectAllLayers },
            },
            [_vm._v("\n      Clear selection\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "position-fixed apply-to-layer-section" },
        [
          _c(
            "b-form-group",
            { staticClass: "d-flex mt-3" },
            [
              _c(
                "div",
                { staticClass: "mr-2 custom-control custom-control-inline" },
                [_vm._v("\n        Apply layer order to:\n      ")]
              ),
              _vm._v(" "),
              _c("SelectLayersTemplateDropdown", {
                ref: "selectLayersDropdown",
                staticClass: "d-inline",
                attrs: {
                  "local-storage-key": "selected-templates-for-layers-order",
                  "clear-local-storage": true,
                },
                on: { "call-apply": _vm.applyOrder },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isMoreThanOneSelected
        ? _c(
            "b-button-group",
            { staticClass: "w-100", attrs: { size: "sm" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "cursor-pointer mt-2 custom-secondary-button",
                  attrs: { variant: "outline-primary", size: "sm" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleMultipleLayersVisibility.apply(
                        null,
                        arguments
                      )
                    },
                  },
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: _vm.getSelectionVisibilityIcon },
                  }),
                  _vm._v("\n      Toggle selection visibility\n    "),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-button-group",
        { staticClass: "d-flex flex-column w-100", attrs: { size: "sm" } },
        [
          _vm.canBeDuplicated || _vm.isDuplicating
            ? _c(
                "b-button",
                {
                  staticClass:
                    "cursor-pointer custom-secondary-button text-xs mt-2",
                  class: { "opacity-50": _vm.isDuplicating },
                  attrs: {
                    variant: "outline-primary",
                    size: "sm",
                    disabled: _vm.isDuplicating,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleDuplicateSelectedLayer.apply(
                        null,
                        arguments
                      )
                    },
                  },
                },
                [
                  !_vm.isDuplicating
                    ? _c("i", { staticClass: "bi bi-copy mr-1" })
                    : _c("b-spinner", {
                        staticClass: "mr-1",
                        attrs: { small: "" },
                      }),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.isDuplicating ? "Duplicating..." : "Duplicate Layer"
                      ) +
                      "\n    "
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("RestoreSeeThrough"),
          _vm._v(" "),
          _vm.canBeDeleted || _vm.isDeleting || _vm.deleteGroup
            ? _c(
                "b-button",
                {
                  staticClass:
                    "cursor-pointer mt-2 custom-secondary-button text-xs",
                  class: { "opacity-50": _vm.isDeleting },
                  staticStyle: { color: "#dc3545" },
                  attrs: {
                    variant: "outline-danger",
                    size: "sm",
                    disabled: _vm.isDeleting,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleDeleteLayer.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm.isDeleting
                    ? _c("b-spinner", {
                        staticClass: "mr-1",
                        attrs: { small: "" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("i", { staticClass: "bi bi-trash mr-1" }),
                  _vm._v(
                    "Delete " +
                      _vm._s(_vm.deleteGroup ? "group" : "layer") +
                      "\n    "
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canBeCopied || _vm.isCopying
            ? _c(
                "b-button",
                {
                  staticClass:
                    "cursor-pointer mt-2 custom-secondary-button text-xs font-semibold",
                  class: { "opacity-50": _vm.isCopying },
                  attrs: {
                    variant: "outline-primary",
                    size: "sm",
                    disabled: _vm.isCopying,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleAddingToAllTemplates.apply(
                        null,
                        arguments
                      )
                    },
                  },
                },
                [
                  !_vm.isCopying
                    ? _c("i", { staticClass: "bi bi-file-earmark-plus mr-1" })
                    : _c("b-spinner", {
                        staticClass: "mr-1",
                        attrs: { small: "" },
                      }),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.isCopying ? "Adding..." : _vm.getCopyButtonText
                      ) +
                      "\n    "
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }